import { render, staticRenderFns } from "./JumbotronCard.vue?vue&type=template&id=749ca58f&scoped=true&"
import script from "./JumbotronCard.vue?vue&type=script&lang=js&"
export * from "./JumbotronCard.vue?vue&type=script&lang=js&"
import style0 from "./JumbotronCard.vue?vue&type=style&index=0&id=749ca58f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749ca58f",
  null
  
)

export default component.exports